import LegalDocument, { LegalList, LegalSection } from "../components/LegalDocument";
import { brandIdentity } from "../data/brand";

export default function TermsOfUse() {
  return (
    <LegalDocument
      path="/terms-of-use"
      title="Terms of Use"
      seoTitle="Terms of Use TechniaHQRobot"
      description="These terms explain permitted website use, editorial limitations, intellectual property, external services, submissions, advertising and liability."
      eyebrow="Website rules"
      updatedAt="August 4, 2026"
      schemaType="WebPage"
    >
      <LegalSection id="acceptance" title="1. Acceptance of these terms">
        <p>
          These Terms of Use apply when you access or use {brandIdentity.baseUrl}. By continuing to use the website, you agree to these terms and the Privacy Policy. Stop using the site if you do not agree.
        </p>
      </LegalSection>

      <LegalSection id="editorial" title="2. Editorial information, not professional advice">
        <p>
          TechniaHQRobot publishes reporting, analysis, guides, directories and commentary about robotics, Physical AI, artificial intelligence, social platforms and other covered subjects. Content is provided for general information. It is not engineering certification, investment advice, legal advice, medical advice, safety approval or a guarantee that a product will perform as described in every environment.
        </p>
        <p>
          Robotics specifications, prices, availability, software versions and company claims can change. Articles may distinguish confirmed evidence from interpretation, but readers should verify primary documentation before making a purchase, investment, deployment or safety decision.
        </p>
      </LegalSection>

      <LegalSection id="use" title="3. Permitted and prohibited use">
        <p>You may read, link to and share public TechniaHQRobot pages for lawful purposes. You may not</p>
        <LegalList>
          <li>interfere with the website, bypass access controls or attempt unauthorized access;</li>
          <li>use automated traffic in a way that overloads the site or ignores published technical restrictions;</li>
          <li>copy or republish substantial original articles, graphics or databases without permission;</li>
          <li>remove attribution, copyright notices or source information;</li>
          <li>use the site to distribute malware, spam, impersonation, fraud or unlawful material;</li>
          <li>misrepresent TechniaHQRobot as endorsing a product, company, political position or financial offer.</li>
        </LegalList>
      </LegalSection>

      <LegalSection id="copyright" title="4. Copyright, trademarks and embedded material">
        <p>
          Original TechniaHQRobot text, page design, graphics, datasets and branding are protected by applicable intellectual-property rules. Limited quotation for criticism, reporting or research should remain proportionate, preserve context and include a visible link and attribution.
        </p>
        <p>
          Company names, robot names, logos, videos, posts and other third-party material remain the property of their respective owners. Embedded X posts and linked media are displayed through platform tools or for editorial reference. Their presence does not transfer ownership to TechniaHQRobot or imply endorsement.
        </p>
        <p>
          Copyright or attribution concerns can be sent to <a className="font-black text-blue-700 underline underline-offset-4" href={`mailto:${brandIdentity.email}?subject=Copyright%20request`}>{brandIdentity.email}</a> with the affected URL, the work concerned and a clear explanation of the request.
        </p>
      </LegalSection>

      <LegalSection id="submissions" title="5. Messages, tips and submitted material">
        <p>
          Do not send confidential, proprietary, security-sensitive or embargoed information unless confidentiality has been agreed in writing. Sending a tip or media file does not create an employment, agency, partnership or confidential relationship.
        </p>
        <p>
          When you submit material for possible publication, you confirm that you have the right to share it. Unless different terms are agreed, you grant TechniaHQRobot permission to review, edit, quote, translate and publish the submitted material for editorial and promotional purposes while preserving reasonable attribution.
        </p>
      </LegalSection>

      <LegalSection id="ads" title="6. Advertising, sponsorships and affiliate relationships">
        <p>
          The website may display third-party advertising, sponsored content, direct advertising links or paid partnerships. Sponsored material should be identified. Payment does not guarantee positive coverage or turn an unverified technical claim into a confirmed fact.
        </p>
        <p>
          Advertisers and external platforms are responsible for their products, claims, availability, payment systems and privacy practices. An advertisement appearing beside an article does not mean TechniaHQRobot endorses it.
        </p>
      </LegalSection>

      <LegalSection id="external" title="7. External websites and services">
        <p>
          Links, embedded posts, videos, app stores and social profiles can take you to services controlled by other organizations. TechniaHQRobot does not control their uptime, content, tracking, security or terms. Review the destination before providing information, installing software or making a payment.
        </p>
      </LegalSection>

      <LegalSection id="availability" title="8. Availability and corrections">
        <p>
          The website may be changed, suspended or removed without notice. TechniaHQRobot may correct factual errors, update sources, change titles, remove unsafe links or revise pages when new evidence becomes available. There is no guarantee that every page will remain available or error-free.
        </p>
      </LegalSection>

      <LegalSection id="liability" title="9. Disclaimer and limitation of liability">
        <p>
          The website is provided on an “as available” basis. To the maximum extent permitted by applicable law, TechniaHQRobot disclaims implied warranties concerning accuracy, availability, merchantability, fitness for a particular purpose and non-infringement.
        </p>
        <p>
          To the maximum extent permitted by applicable law, TechniaHQRobot is not liable for indirect, incidental or consequential loss arising from reliance on website content, external services, advertising, downloads, interrupted access or decisions made using the information. Mandatory consumer rights and liabilities that cannot legally be excluded remain unaffected.
        </p>
      </LegalSection>

      <LegalSection id="changes" title="10. Changes and applicable rules">
        <p>
          These terms may be updated to reflect new features, providers or legal requirements. The version published on this page applies from its stated update date. Any dispute remains subject to mandatory laws and consumer protections that apply to the user and the website operator.
        </p>
      </LegalSection>

      <LegalSection id="contact" title="11. Contact">
        <p>
          Questions about these terms can be sent to <a className="font-black text-blue-700 underline underline-offset-4" href={`mailto:${brandIdentity.email}?subject=Terms%20of%20Use`}>{brandIdentity.email}</a>.
        </p>
      </LegalSection>
    </LegalDocument>
  );
}
